import React, { useState, useEffect } from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { number, string } from 'prop-types';
import { useSubmitHelpful } from '../../../hooks/index';
import { dataModel } from '../dataModel';
import '../Voting.scss';

const Vote = (props) => {
  const { totalPositiveFeedbackCount, answerId } = props;

  const [voted, setVoted] = useState(false);

  const postHelpfulData = {
    id: answerId,
    feedbacktype: 'helpfulness',
    contenttype: 'answer',
    vote: 'positive'
  };

  const [submitHelpful, helpfulResponse] = useSubmitHelpful(postHelpfulData);

  const handleHelpful = () => {
    submitHelpful();
  };

  useEffect(() => {
    if (helpfulResponse.data) {
      const feedback = helpfulResponse.data.submitReviewFeedback;
      if (feedback.Feedback.FeedbackHelpfulness) {
        setVoted(true);
      }
    }
  }, [helpfulResponse]);

  return (
    <div className="vote-container">
      <Button
        className={`helpful-button ${voted ? 'voted' : ''}`}
        onClick={handleHelpful}
        title="Helpful"
        disabled={voted}
        inline
        outline
        small
      >
        {voted ? 'Helpful!' : 'Helpful?'}
      </Button>
      {totalPositiveFeedbackCount > 0 ? (
        <span className="helpful-count">
          {voted ? totalPositiveFeedbackCount + 1 : totalPositiveFeedbackCount}{' '}
          found this answer helpful
        </span>
      ) : (
        <span className="helpful-count">
          {voted
            ? `${totalPositiveFeedbackCount + 1} found this answer helpful`
            : null}
        </span>
      )}
    </div>
  );
};

Vote.dataModel = dataModel;

Vote.propTypes = {
  totalPositiveFeedbackCount: number,
  answerId: string.isRequired
};

Vote.defaultProps = {
  totalPositiveFeedbackCount: 0
};

Vote.displayName = 'Vote';

export { Vote };
